const cmpAvailableEvent = "alma_cmp_v2_consents_available_repetitive";
const userOptedInEvent = "alma_cmp_v2_has_optedin";

const purposes = {
  std: "1",
  google: "8",
};

const nonTcfPurposes = {
  fb: 1,
  google: 3,
};

export const defaultCMPData = {
  standard: false,
  facebook: false,
  google: false,
  ga: false,
};

const hasStdConsent = (standard) => !!standard?.[purposes.std];
const hasFbConsent = (nonTcf) => !!nonTcf?.[nonTcfPurposes.fb];
const hasGoogleConsent = (standard, nonTcf) => hasStdConsent(standard) && !!nonTcf?.[nonTcfPurposes.google];
const hasGAConsent = (standard, nonTcf) => hasGoogleConsent(standard, nonTcf) && !!standard?.[purposes.google];

export const getCMPDataObject = (standard, nonTcf) => ({
  standard: hasStdConsent(standard),
  facebook: hasFbConsent(nonTcf),
  google: hasGoogleConsent(standard, nonTcf),
  ga: hasGAConsent(standard, nonTcf),
});

export const getCMPData = async ([standard, nonTcf]) => getCMPDataObject(standard, nonTcf);

// vendor 1 = facebook, value = boolean
export const getNonTcfConsents = () => new Promise((resolve) => window.ALMA.cmpV2.getNonTCFVendorConsents(resolve));

export const getStandardPurposes = async (consentData) => consentData?.detail?.standard;

export const processCmpData = (details) =>
  Promise.all([getStandardPurposes(details), getNonTcfConsents()]).then(getCMPData);

export const handleCMPEvent = (cb) => (details) => processCmpData(details).then(cb);

export const addUserOptedInListener = (cb) => window.addEventListener(userOptedInEvent, handleCMPEvent(cb), false);

export default (cb) => {
  const handleEvent = (details) => {
    window.removeEventListener(cmpAvailableEvent, handleEvent, false);
    handleCMPEvent(cb)(details);
  };
  window.addEventListener(cmpAvailableEvent, handleEvent, false);
};
